import type { TenantOption } from '@valiosascrm/shared';

/** Same deterministic order for the login default and the tenant dropdown. */
export function sortClinics<T extends Pick<TenantOption, 'id' | 'name'>>(clinics: readonly T[]): T[] {
  return [...clinics].sort((a, b) =>
    a.name.localeCompare(b.name, 'pt-BR') || a.id.localeCompare(b.id),
  );
}

type TenantProfile = {
  tenantId?: string;
  tenant?: { id?: string; slug?: string | null } | null;
  clinics?: Array<{ id?: string; slug?: string | null }> | null;
};

export function activeTenantSlug(user: TenantProfile | null): string | null {
  if (!user) return null;
  if (user.tenantId) {
    return (user.tenant?.id === user.tenantId ? user.tenant.slug : null)
      || user.clinics?.find((clinic) => clinic.id === user.tenantId)?.slug
      || null;
  }
  return user.tenant?.slug || null;
}

export function clearLegacyLocation() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem('valiosascrm-selected-location');
  } catch {
    // A disabled/full browser store must not interrupt an authenticated switch.
    // No operational screen reads this retired preference anymore.
  }
}
